import { render } from "./footerNav.vue?vue&type=template&id=ecc08548&scoped=true"
const script = {}

import "./footerNav.vue?vue&type=style&index=0&id=ecc08548&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc08548"]])

export default __exports__